import {EndDetector} from '../domain/page';
async function loadAllImages(): Promise<void> {
    document.querySelectorAll<HTMLImageElement>('img[src]').forEach(img => {
        img.src = img.getAttribute('src') || ''; // Aseguramos que el src no sea null
        img.onload = () => console.log('Imagen cargada:', img.src);
        img.onerror = () => console.error('Error cargando la imagen:', img.src);
    });
    const images: HTMLCollectionOf<HTMLImageElement> = document.images;
    const loadPromises: Promise<void>[] = [];
    console.log(images.length);
    for (const img of Array.from(images)) {
        const promise = new Promise<void>((resolve, reject) => {
            if (img.complete && img.naturalHeight !== 0) {
                console.log("previously complieted")
                resolve();
            } else {
                console.log("post complieted")
                img.addEventListener('load', () => resolve());
                //Maximum amount of time
                setTimeout(()=>resolve(),5000)
                img.addEventListener('error', () => {
                    console.error(`Error loading image: ${img.src}`);
                    resolve(); // Aún resuelve para no detener todo el proceso debido a un error
                });
            }
        });
        loadPromises.push(promise);
    }

    await Promise.all(loadPromises);
    console.log('All images loaded!');
}

export class Vue2EndDetector implements EndDetector {
    async waitStillIsReady(): Promise<void> {
        await loadAllImages();
    }
}